import React from "react";
import AgGrid from "../AgGrid";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import GlobalService from "../../../services/Global";
import { useCallback } from "react";
import { useState } from "react";
import { ItemColumnDef } from "./ItemColumnDef";
import { useLocation, useNavigate } from "react-router-dom";

const ItemTable = ({
  gridRef,
  onGridReady,
  rowSelection,
  height,
  enableCheckbox,
  rowData,
  onRowDoubleClicked,
  enableRangeSelection,
  getRowId,
  onRowClicked,
}) => {
  const { t } = useTranslation();
  const [tagList] = useState();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const getAllTag = useCallback(async () => {
    const { results } = await GlobalService.getTagList({
      startRow: 0,
      endRow: 9999,
    });
    // console.log("results", results);
    const mapTagValue = results.map((tag) => {
      return {
        ...tag,
        value: tag.name,
        label: tag.name,
      };
    });
    // setTagList(mapTagValue);
    return mapTagValue;
  }, []);

  useEffect(() => {
    getAllTag();
  }, [getAllTag]);

  const onClickTagListHandler = (tagName) => {
    navigate(`${pathname}?filterTag=` + tagName);
  };

  return (
    <AgGrid
      ref={gridRef}
      columnDefs={ItemColumnDef(
        t,
        enableCheckbox,
        tagList,
        onClickTagListHandler,
        getAllTag
      )}
      height={height}
      onGridReady={onGridReady}
      rowSelection={rowSelection}
      rowMultiSelectWithClick={rowSelection !== "single"}
      rowData={rowData}
      onRowDoubleClicked={onRowDoubleClicked}
      onRowClicked={onRowClicked}
      enableRangeSelection={enableRangeSelection}
      getRowId={getRowId}
    />
  );
};

export default ItemTable;
